/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscriptionalertpurchasefailedtitle4Inputs */



/**
* | output |
* | --- |
* | "Purchase error" |
*
* @param {Subscriptionalertpurchasefailedtitle4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const subscriptionalertpurchasefailedtitle4 = /** @type {((inputs?: Subscriptionalertpurchasefailedtitle4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscriptionalertpurchasefailedtitle4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Purchase error")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error de compra")
	return /** @type {LocalizedString} */ ("Ошибка покупки")
});
export { subscriptionalertpurchasefailedtitle4 as "subscriptionAlertPurchaseFailedTitle" }